module.exports = __webpack_public_path__ + "23d9069b737b3049fe859bc9c17bbd24.png";